import template from './attendance.html';
import controller from './attendance.controller';
import './attendance.scss';

let attendanceComponent = {
  bindings: {},
  template,
  controller
};

export default attendanceComponent;



// WEBPACK FOOTER //
// ./client/app/components/attendance/attendance.component.js